import type { ChatMessage } from '@pullman/shared';
import { UserBubble } from './UserBubble';
import { AIBubble } from './AIBubble';

interface MessageBubbleProps {
  message: ChatMessage;
  onSendMessage?: (text: string) => void;
}

export function MessageBubble({ message, onSendMessage }: MessageBubbleProps) {
  if (message.role === 'user') {
    return <UserBubble message={message} />;
  }
  return <AIBubble message={message} onSendMessage={onSendMessage} />;
}
